module.exports = __webpack_public_path__ + "static/media/fz_verifylocalsuccess_pt_PT.ebba46a2.png";